import { useSelector } from 'react-redux'
import { useQueryTransactionDetail } from 'src/queries/transactions.queries'
import { selectActiveOrgIntegration } from 'src/redux/selectors/data/orgIntegrations.selectors'

export const useQueryActiveTransactionIntegration = (
  transactionId: string | undefined,
) => {
  const { data: transaction, isPending } = useQueryTransactionDetail({
    transactionId,
  })
  // TODO: move everything to react query and use useQueries with a combine
  // https://tanstack.com/query/latest/docs/framework/react/reference/useQueries
  const activeOrgIntegration = useSelector(selectActiveOrgIntegration)
  return {
    data: transaction?.connectedPlatforms?.find(
      (connection) =>
        connection.platform === activeOrgIntegration?.connectedPlatform,
    ),
    pending: isPending,
  }
}

export const useQueryActiveConnectedPlatformName = (
  transactionId: string | undefined,
) => {
  const {
    data: activeTransactionIntegration,
    pending: activeTransactionIntegrationPending,
  } = useQueryActiveTransactionIntegration(transactionId)
  // TODO: move everything to react query and use useQueries with a combine
  // https://tanstack.com/query/latest/docs/framework/react/reference/useQueries
  const activeOrgIntegration = useSelector(selectActiveOrgIntegration)
  return {
    data:
      activeTransactionIntegration && activeOrgIntegration
        ? activeOrgIntegration.platformName
        : undefined,
    pending: activeTransactionIntegrationPending,
  }
}
